export class CustomerLegalForm {
  id?: number;
  name?: string;
  shortName?: string;
  country?: string;
}
